export const HighlightBtn = ({ icon: Icon, text }) => {
    return (
        <div className="d-flex gap-3 align-items-center mb-3">
            <Icon className="fs-3 text-important" />
            <p className="mb-0 fs-6">{text}</p>
        </div>
    )
}
